export default [
  {
    id: 'Buckaroo_Instant_Ideal',
    label: 'iDEAL',
    issuers: [
      {
        id: 'INGBNL2A',
        label: 'ING Bank',
        __typename: 'PaymentMethodIssuer',
        value: 'ingbnl2a',
      },
      {
        id: 'ABNANL2A',
        label: 'ABN Amro Bank',
        __typename: 'PaymentMethodIssuer',
        value: 'abnanl2a',
      },
      {
        id: 'RABONL2U',
        label: 'Rabobank',
        __typename: 'PaymentMethodIssuer',
        value: 'rabonl2u',
      },
      {
        id: 'SNSBNL2A',
        label: 'SNS Bank',
        __typename: 'PaymentMethodIssuer',
        value: 'snsbnl2a',
      },
      {
        id: 'ASNBNL21',
        label: 'ASN Bank',
        __typename: 'PaymentMethodIssuer',
        value: 'asnbnl21',
      },
      {
        id: 'TRIONL2U',
        label: 'Triodos Bank',
        __typename: 'PaymentMethodIssuer',
        value: 'trionl2u',
      },
      {
        id: 'RBRBNL21',
        label: 'Regio Bank',
        __typename: 'PaymentMethodIssuer',
        value: 'rbrbnl21',
      },
      {
        id: 'KNABNL2H',
        label: 'KNAB Bank',
        __typename: 'PaymentMethodIssuer',
        value: 'knabnl2h',
      },
      {
        id: 'FVLBNL22',
        label: 'van Lanschot Bankiers',
        __typename: 'PaymentMethodIssuer',
        value: 'fvlbnl22',
      },
      {
        id: 'BUNQNL2A',
        label: 'Bunq',
        __typename: 'PaymentMethodIssuer',
        value: 'bunqnl2a',
      },
    ],
    disabled: false,
    transactionCost: {
      value: 0,
      currency: 'EUR',
      __typename: 'Money',
    },
    image: {
      file: {
        url: '',
      },
      title: '',
    },
    paymentInformationFields: [],
  },
  {
    id: 'Cg_Test',
    label: 'Test',
    issuers: [],
    disabled: false,
    transactionCost: {
      value: 0,
      currency: 'EUR',
      __typename: 'Money',
    },
    image: {
      file: {
        url: '',
      },
      title: '',
    },
    paymentInformationFields: [],
  },
  {
    id: 'Paypal_Expresscheckout',
    label: 'PayPal',
    issuers: [],
    disabled: false,
    transactionCost: {
      value: 0,
      currency: 'EUR',
      __typename: 'Money',
    },
    image: {
      file: {
        url: '',
      },
      title: '',
    },
    paymentInformationFields: [
      {
        key: 'BILLING_FIRSTNAME',
        inputType: 'text',
        placeholder: 'first_name',
        dimensions: {
          desktop: '1/2',
          mobile: 'full',
        },
        validations: {
          required: true,
        },
      },
      {
        key: 'BILLING_LASTNAME',
        inputType: 'text',
        placeholder: 'last_name',
        dimensions: {
          desktop: '1/2',
          mobile: 'full',
        },
        validations: {
          required: true,
        },
      },
      {
        inputType: 'text',
        key: 'BILLING_STREET',
        placeholder: 'address',
        dimensions: {
          desktop: '3/4',
          mobile: '3/4',
        },
        validations: {
          required: true,
        },
      },
      {
        inputType: 'text',
        key: 'BILLING_CITY',
        placeholder: 'city',
        dimensions: {
          desktop: '1/2',
          mobile: '1/2',
        },
        validations: {
          required: true,
        },
      },
      {
        inputType: 'text',
        key: 'BILLING_POSTALCODE',
        placeholder: 'postal_code',
        dimensions: {
          desktop: '1/2',
          mobile: '1/2',
        },
        validations: {
          required: true,
        },
      },
    ],
  },
  {
    id: 'Adyen_Visa',
    label: 'Visa',
    issuers: [],
    disabled: false,
    transactionCost: {
      value: 0,
      currency: 'EUR',
      __typename: 'Money',
    },
    image: {
      file: {
        url: '',
      },
      title: '',
    },
    paymentInformationFields: [],
  },
  {
    id: 'Telserv_Ivr',
    label: 'Telefoon/Beltegoed',
    issuers: [],
    disabled: false,
    transactionCost: {
      value: 518,
      currency: 'EUR',
      __typename: 'Money',
    },
    image: {
      file: {
        url: '',
      },
      title: '',
    },
    paymentInformationFields: [],
  },
  {
    id: 'Adyen_Mastercard',
    label: 'Mastercard',
    issuers: [],
    disabled: true,
    transactionCost: null,
    image: {
      file: {
        url: '',
      },
      title: '',
    },
    paymentInformationFields: [],
  },
  {
    id: 'Buckaroo_Instant_Banktransfer',
    label: 'Bankoverschrijving',
    issuers: [],
    disabled: true,
    transactionCost: null,
    image: {
      file: {
        url: '',
      },
      title: '',
    },
    paymentInformationFields: [],
  },
]
